import { type MetaFunction } from 'react-router'
import { pageMeta } from '#app/utils/page-meta.ts'

export const meta: MetaFunction = (args) =>
	pageMeta(args, { title: 'Sletting av data' })

/**
 * Meta requires this page for apps that use Facebook Login (User Data
 * Deletion). Looked up from "User data deletion" in the Meta app settings.
 */
export default function DataDeletionRoute() {
	return (
		<div className="container mx-auto max-w-2xl p-8">
			<h1 className="text-h2">Sletting av data</h1>
			<div className="prose-sm prose mt-4 space-y-4">
				<p>
					Har du logga inn hjå oss med Facebook, kan du slette dataa dine slik:
				</p>
				<ol className="list-decimal space-y-2 pl-6">
					<li>
						<strong>Slett brukaren hjå oss:</strong> gå til «
						<a href="/settings/profile" className="underline">
							Profil og innstillingar
						</a>
						» og trykk «Slett brukaren min og alle dataa». Då slettar vi
						brukaren din og koplinga til Facebook. Du kan òg sende e-post til{' '}
						<a href="mailto:heia@huskonsertfestivalen.no" className="underline">
							heia@huskonsertfestivalen.no
						</a>
						, så slettar vi han for deg.
					</li>
					<li>
						<strong>Fjern appen hjå Facebook:</strong> Facebook → Innstillinger
						→ Apper og nettsteder → «Huskonsertfestivalen» → «Fjern». Då får vi
						ikkje lenger tilgang til Facebook-kontoen din. Brukaren hjå oss blir
						ikkje sletta av dette, så gjer òg steg 1.
					</li>
				</ol>
				<p>
					Billettar og betalingar må vi ta vare på ei stund etter at brukaren er
					sletta, mellom anna fordi bokføringslova krev det. Kva vi tek vare på
					og kor lenge, står i <a href="/privacy">personvernerklæringa</a>.
				</p>
			</div>
		</div>
	)
}
